import React from 'react';

const Button = props => {
  const { children, prefix, size = 'large', type = 'default', className = '', onClick, href } = props;
  const fontSize = size === 'large' ? 'font-24' : 'font-16';
  const hasPrefix = prefix ? 'prefix' : '';

  const classNames = `duoke-btn ${size} ${fontSize} ${type} ${hasPrefix} ${className}`;

  return (
    <a href={href} className={classNames}>
      {prefix ? prefix : null}
      <button onClick={onClick}>{children}</button>
    </a>
  );
};

export default Button;
